import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";

export class Sticky extends React.Component {
  constructor(props) {
    super(props);
    this.makeSticky = this.makeSticky.bind(this);
  }

  componentDidMount() {
    const rootMargin = get(this.props, ["rootMargin"], "0px 0px 0px 0px");
    const options = {
      threshold: [0, 1],
      rootMargin: rootMargin
    };

    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(this.makeSticky, options);
      const observerElement = this.props.observerElement || "observerElement";
      // Instead of targeting the children, we are targeting the observer el which is a hidden `div` above the children of `Sticky`.
      const target = document.querySelector("#" + observerElement);
      this.observer.observe(target);
    }
  }

  makeSticky(entries, observer) {
    const fixedClassName = "sticky-element__wrapper--fixed";
    const elementHeight = this.wrapperEl.offsetHeight;

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.wrapperEl.classList.remove(fixedClassName);
        this.holderEl.style.height = "auto";
      } else {
        // this will also be executed when the target is moving out of the viewport
        // from the bottom which we don't need
        this.wrapperEl.classList.add(fixedClassName);
        this.holderEl.style.height = elementHeight + "px";
      }
    });
  }

  componentWillUnmount() {
    this.observer && this.observer.disconnect();
  }

  render() {
    return (
      <div ref={holder => (this.holderEl = holder)} className="sticky-element">
        {/* the below element__observer won't show anything. This div is used to check the current position/flow of sticky element */}
        <div id={this.props.observerElement || "observerElement"} />
        <div ref={wrapper => (this.wrapperEl = wrapper)} className="sticky-element__wrapper">
          {this.props.children}
        </div>
      </div>
    );
  }
}
Sticky.propTypes = {
  observerElement: PropTypes.string,
  children: PropTypes.object
};
